import { zodResolver } from "@hookform/resolvers/zod";
import { useIntersectionObserver } from "@uidotdev/usehooks";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { formSchema } from "../../pages/ContactPage";
import { https } from "../../services/AxiosConfig";
import { LeafButton } from "../buttons";
import { ContactItems } from "./ContactItem";

export const Contact = ({
  header,
  headertitle,
  headerdes,
  strong,
  headerdes2,
  connectUsdes1,
  headerdes3,
}) => {
  const [focused, setFocused] = useState(false);
  const { t } = useTranslation();
  const [ref3, entry3] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
      company_name: "",
      product_name: "",
      message: "",
    },
  });
  const [isVisible3, setIsVisible3] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  function onSubmit(values) {
    setIsLoading(true);
    https
      .post("contact", values)
      .then(() => {
        reset();
        toast(t("content_106"), {
          className: "!bg-green-100 !border-green-500 !text-inherit",
        });
      })
      .catch(() => {
        toast(t("msg_error_3"), {
          className: "!bg-red-100 !border-red-500 !text-inherit",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    if (entry3 && entry3.isIntersecting && !isVisible3) {
      setIsVisible3(true); // Đánh dấu đã gặp isIntersecting
    }
  }, [entry3, isVisible3]);

  return (
    <div ref={ref3}>
      <div
        className={`bg-no-repeat bg-contact bg-center sm600:bg-cover px-4 w-full h-full ${isVisible3 ? "animate-zoomIn" : null}`}
      >
        <div className="mx-auto flex max-w-[1280px] flex-col py-[50px] pt-[50px] ">
          <div className="flex flex-col items-center justify-center ">
            <h1 className="max-w-[870px] text-center text-[36px] font-bold text-[--color-title]">
              {header}{" "}
              <span className="text-[--color-hover]">{headertitle}</span>
            </h1>
            <p className="text-4 mt-[20px] max-w-[870px] text-center text-[#3d2e7c]">
              {headerdes}
              {strong && (
                <a href="#" className="text-[#565ADD] hover:underline">
                  {strong}
                </a>
              )}
              {headerdes3 && <span className="font-bold">{headerdes3}</span>}
              {headerdes2}
            </p>
            {connectUsdes1 && (
              <p className="text-4 mt-[16px] max-w-[870px] text-center text-[#3d2e7c]">
                {connectUsdes1}
              </p>
            )}
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mx-auto mt-5 grid sm600:grid-cols-1 w-[90%] grid-cols-2 gap-[12px] bg-[no-repeat] bg-contactSale bg-center">
              <ContactItems
                label={t("homepage.first")}
                placeholder={t("homepage.first1")}
                {...register("first_name")}
                error={errors.first_name}
              />
              <ContactItems
                label={t("homepage.lastName")}
                placeholder={t("homepage.lastName1")}
                {...register("last_name")}
                error={errors.last_name}
              />
              <ContactItems
                label={t("homepage.yourphone")}
                placeholder={t("homepage.yourphone1")}
                {...register("phone")}
                error={errors.phone}
              />
              <ContactItems
                label={t("homepage.email")}
                placeholder={t("homepage.email1")}
                {...register("email")}
                error={errors.email}
              />
              <ContactItems
                label={t("homepage.company")}
                placeholder={t("homepage.company1")}
                {...register("company_name")}
                error={errors.company_name}
              />
              <ContactItems
                label={t("homepage.products")}
                placeholder={t("homepage.products1")}
                {...register("product_name")}
                error={errors.product_name}
              />
              <div className="col-span-full flex flex-col px-[20px] py-[5px]">
                <p className="text-4 mb-[4px] text-[--color-title]">
                  {t("homepage.mess")}
                </p>
                <textarea
                  className="h-[105px] min-h-[125px] w-full rounded-[30px] border border-[#565ADD] p-[12px] focus:border  focus:border-solid focus:border-[#565ADD] focus:shadow-focus-input focus:outline-none"
                  placeholder={focused ? "" : t("homepage.mess1")}
                  onFocus={() => setFocused(true)}
                  onBlur={() => setFocused(false)}
                  type="text"
                  {...register("message")}
                />
                {errors.message && (
                  <span className="mt-1 text-sm text-red-500">
                    {t(errors.message.message)}
                  </span>
                )}
              </div>
            </div>
            <div className="mt-6 flex items-center justify-center">
              <LeafButton
                type="submit"
                title={t("homepage.submit")}
                disabled={isLoading}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
Contact.propTypes = {
  header: PropTypes.string,
  headertitle: PropTypes.string,
  headerdes: PropTypes.string,
  strong: PropTypes.string,
  headerdes2: PropTypes.string,
};
